export default __webpack_public_path__ + "static/media/Hand_right.4658b219.svg";